import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsDeveloperWorkloadRoute: InvariantJiraRoute = {
	name: 'legacy-reports-developer-workload-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'],
};
